
import VerifiyDocument from '../../documents/VerifiyDocument';

import classes from './HistoryModal.module.css'
import BodySimpleModalV3 from '../../../../../common/modal/BodySimpleModalV3';
import { formatDateLocalWithTimeWithoutSeconds } from '../../../../../../lib/script';


export default function HistoryModal({children, history, uploadedDocument, modalRight, hideVerifyAction, appendToMessage}) {

    const historyList = Array.isArray(history) ? history : []
    const hasHistory = historyList.length > 0
    const hasAppend = appendToMessage != null && appendToMessage !== false
    const showVerify = uploadedDocument && !uploadedDocument.is_verified && !hideVerifyAction

    if (!hasHistory && !hasAppend && !showVerify) {
        return <div className={classes.container}>{children}</div>
    }

    const modalHtml = <>
        {hasHistory && <div className={classes.fixed_message_inner} >
            {historyList.map(item => (
                <div key={item.date + item.action}  className={classes.history_item}>
                    {item.action == 'viewed' && <div className={classes.history_item_inner}>
                        <i className="ti ti-eye-check"></i>
                        <div>
                            <div className=''>
                                Viewed by <strong>{item.name}</strong>    
                            </div>
                            <div className={classes.date}>
                                {formatDateLocalWithTimeWithoutSeconds(item.date)}
                            </div>
                        </div>
                    </div>}
                    {item.action == 'verified' && <div className={`${classes.history_item_inner} ${classes.verified}`}>
                        <i className="ti ti-checks"></i>
                        <div>
                            <div className=''>
                                Verified by <strong>{item.name}</strong>    
                            </div>
                            <div className={classes.date}>
                                {formatDateLocalWithTimeWithoutSeconds(item.date)}
                            </div>
                        </div>
                    </div>}
                </div>
            ))}                
        </div>}
        {showVerify && <div className={classes.verify_container}>
            <VerifiyDocument documentId={uploadedDocument.id}>
                <i className="ti ti-checks"></i> Mark as verified
            </VerifiyDocument>
        </div> }
        {hasAppend && <div className={classes.append_section}>{appendToMessage}</div>}
    </>

    return <div className={classes.container}>
        <BodySimpleModalV3 message={modalHtml} widthAuto>
            {children}
        </BodySimpleModalV3>  
    </div>
}
